/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, FormHelperText
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _, { forEach } from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from "moment";

var screenCode = "FCCIQVSOQREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'productSubCategoryName',
        numeric: false,
        disablePadding: false,
        label: 'SKU Category',
        align: "left"
    },
    {
        id: 'orderedQty',
        numeric: true,
        disablePadding: false,
        label: 'Ordered Qty',
        align: "right"
    },
    {
        id: 'suppliedQty',
        numeric: true,
        disablePadding: false,
        label: 'Supplied Qty',
        align: "right"
    },
    {
        id: 'fillRate',
        numeric: true,
        disablePadding: false,
        label: 'Fill Rate',
        align: "right"
    },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function FCCIQVsOQReport() {

    const navigate = useNavigate();
    const componentRef = useRef();

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [date, setDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        date: new Date(date).toISOString(),
        toDate: new Date(date).toISOString(),
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        date: '',
        toDate: '',
    });
    const [totalValues, setTotalValues] = useState({
        totalweightedQty: 0,
        totalgrnAmount: 0,
        totalGtnQty: 0,
        totalVariance: 0
    });

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, reportData.length - page * rowsPerPage);

    const priceNegotiationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one fresh collection center')
            .required('Please select at least one fresh collection center'),
        date: Yup.date().min(1).min(1, 'Please Select From Date').required('From Date required'),
        toDate: Yup.date().min(1).min(1, 'Please Select To Date').required('To Date required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            cropID: selectedProductOptions,
            date: formData.date,
            toDate: formData.toDate,
        },
        validationSchema: priceNegotiationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === factory.length ? [] :
                    factory.map((option) => option.value)
            );
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setPage(0);
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [formik.values.cropCategoryID, formik.values.cropID, date, toDate, selectedOptions, selectedCategoryOptions, selectedProductOptions,]);

    useEffect(() => {
        setPage(0);
        setSelectedProductOptions([])
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
        setDate(new Date());
        setToDate(new Date());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setToDate(new Date());
    }, [date]);

    useEffect(() => {
        if (reportData.length != 0) {
            trackPromise(calculateTotalQty())
        }
    }, [reportData]);

    useEffect(() => {
        setPage(0);
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productSubCategoryID: selectedCategoryOptions
        })
    }, [selectedOptions, selectedCategoryOptions]);


    useEffect(() => {
        setPage(0);
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFCCIQVsOQReport');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function SubmitForm() {
        let model = {
            groupID: formik.values.groupID,
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            date: date,
            toDate: toDate,
        }
        var response = await services.GetFCCIQVsOQReport(model);
        response.forEach(x => {
            if (x && x.inBound?.length) {
                const weightedQty = x.inBound[0]?.weightedQty || 0;
        
                let totalGtnQty = 0;
                if (x.outBound?.length) {
                    totalGtnQty = x.outBound.reduce((sum, item) => sum + (item.gtnQty || 0), 0);
                }
                x.variance = weightedQty - totalGtnQty;
            } else {
                x.variance = 0;
            }
        });
        const groupedData = response.reduce((acc, item) => {
            const key = `${item.orderNo}-${item.skuCode}`;
            
            if (!acc[key]) {
                acc[key] = {
                    factoryName: item.factoryName,
                    orderNo: item.orderNo,
                    skuCode: item.skuCode,
                    skuDes: item.skuDes,
                    inBound: [{ 
                        grnAmount: 0, 
                        grnPrice: item.inBound?.[0]?.grnPrice || 0,
                        weightedQty: 0 ,
                        weightedDate:item.inBound?.[0].weightedDate,
                    }],
                    outBound: [],
                    variance: 0
                };
            }

            acc[key].inBound[0].grnAmount += item.inBound?.[0]?.grnAmount || 0;
            acc[key].inBound[0].weightedQty += item.inBound?.[0]?.weightedQty || 0;
            acc[key].variance += item.variance || 0;
        
            item.outBound?.forEach(outItem => {
                const outKey = `${outItem.gtnNumber}-${outItem.vehicleNumber}`;
                const existingOutBound = acc[key].outBound.find(o => o.gtnNumber === outItem.gtnNumber && o.vehicleNumber === outItem.vehicleNumber);
                
                if (existingOutBound) {
                    existingOutBound.gtnQty += outItem.gtnQty || 0;
                } else {
                    acc[key].outBound.push({ 
                        gtnDate: outItem.gtnDate,
                        gtnNumber: outItem.gtnNumber,
                        gtnQty: outItem.gtnQty || 0,
                        vehicleNumber: outItem.vehicleNumber
                    });
                }
            });
        
            return acc;
        }, {});

        const groupedArray = Object.values(groupedData);

        setReportData(groupedArray);

        createDataForExcel(groupedArray);
        getSelectedDropdownValuesForReport();
    }

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setReportData([]);
            setSelectedCategoryOptions([]);
            setSelectedProductOptions([]);
        } else {
            setSelectedOptions([]);
            setReportData([]);
            setSelectedCategoryOptions([]);
            setSelectedProductOptions([]);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(reportData);
        var settings = {
            sheetName: 'Quantity Variance FCC IQ Vs OQ Report',
            fileName: 'Quantity Variance FCC IQ Vs OQ Report_' + new Date(date).toISOString().split('T')[0] + '_' + new Date(toDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        const tempcsvHeaders = keys.map((key) => ({ label: key, value: key }));
        let dataA = [
            {
                sheet: 'Quantity FCC IQ Vs OQ Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        let seenRecords = new Set();

        const formatNumberLikeGrid = (value) => {
            if (value === null || value === undefined) return '-';
            const numeric = Number(value);
            if (!Number.isFinite(numeric) || numeric === 0) return '-';
            return numeric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        const formatDateLikeGrid = (value) => {
            if (!value) return '-';
            return moment(value).format('YYYY-MM-DD');
        };
    
        if (array != null) {
            array.forEach(x => {
                if (x.inBound.length > 0) {
                    x.inBound.forEach(y => {
                        let uniqueKey = `${x.factoryName}-${x.skuCode}-${x.skuDes}-${x.orderNo}-${moment(y.weightedDate).format("YYYY-MM-DD")}-${y.weightedQty}-${y.grnPrice}-${y.grnAmount}`;
    
                        if (x.outBound.length > 0) {
                            x.outBound.forEach(z => {
                                if (seenRecords.has(uniqueKey)) {
                                    res.push({
                                        'FCC': '',
                                        'SKU Code': '',
                                        'SKU Description': '',
                                        'Order Number': '',
                                        'Weighted Date': '',
                                        'Weighted Qty': '',
                                        'GRN Price': '',
                                        'GRN Amount': '',
                                        'GTN Date': formatDateLikeGrid(z.gtnDate),
                                        'GTN Number': z.gtnNumber,
                                        'Vehicle Number': z.vehicleNumber,
                                        'GTN Quantity': formatNumberLikeGrid(z.gtnQty),
                                        'Variance': '',
                                    });
                                } else {
                                    seenRecords.add(uniqueKey);
                                    res.push({
                                        'FCC': x.factoryName,
                                        'SKU Code': x.skuCode,
                                        'SKU Description': x.skuDes,
                                        'Order Number': x.orderNo,
                                        'Weighted Date': formatDateLikeGrid(y.weightedDate),
                                        'Weighted Qty': formatNumberLikeGrid(y.weightedQty),
                                        'GRN Price': formatNumberLikeGrid(y.grnPrice),
                                        'GRN Amount': formatNumberLikeGrid(y.grnAmount),
                                        'GTN Date': formatDateLikeGrid(z.gtnDate),
                                        'GTN Number': z.gtnNumber,
                                        'Vehicle Number': z.vehicleNumber,
                                        'GTN Quantity': formatNumberLikeGrid(z.gtnQty),
                                        'Variance': formatNumberLikeGrid(x.variance),
                                    });
                                }
                            });
                        } else {
                            if (seenRecords.has(uniqueKey)) {
                                res.push({
                                    'FCC': '',
                                    'SKU Code': '',
                                    'SKU Description': '',
                                    'Order Number': '',
                                    'Weighted Date': '',
                                    'Weighted Qty': '',
                                    'GRN Price': '',
                                    'GRN Amount': '',
                                    'GTN Date': '-',
                                    'GTN Number': '-',
                                    'Vehicle Number': '-',
                                    'GTN Quantity': '-',
                                    'Variance': '',
                                });
                            } else {
                                seenRecords.add(uniqueKey);
                                res.push({
                                    'FCC': x.factoryName,
                                    'SKU Code': x.skuCode,
                                    'SKU Description': x.skuDes,
                                    'Order Number': x.orderNo,
                                    'Weighted Date': formatDateLikeGrid(y.weightedDate),
                                    'Weighted Qty': formatNumberLikeGrid(y.weightedQty),
                                    'GRN Price': formatNumberLikeGrid(y.grnPrice),
                                    'GRN Amount': formatNumberLikeGrid(y.grnAmount),
                                    'GTN Date': '-',
                                    'GTN Number': '-',
                                    'Vehicle Number': '-',
                                    'GTN Quantity': '-',
                                    'Variance': formatNumberLikeGrid(x.variance),
                                });
                            }
                        }
                    });
                }
            });
    
            res.push({});
    
            var vrTotal = {
                'SKU Code': "Total:",
                'Weighted Qty': formatNumberLikeGrid(totalValues.totalweightedQty),
                'GRN Amount': formatNumberLikeGrid(totalValues.totalgrnAmount),
                'GTN Quantity': formatNumberLikeGrid(totalValues.totalGtnQty),
                'Variance': formatNumberLikeGrid(totalValues.totalVariance)
            };
            res.push(vrTotal);
            res.push({});
        }
    
        return res;
    }
    

    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.map(x => x).join(','),
            productSubCategoryID: categoryName.map(x => x).join(','),
            date: new Date(date).toISOString().split('T')[0],
            toDate: new Date(toDate).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    async function calculateTotalQty() {
        var totalWeightedQty = 0;
        var totalGrnAmount = 0;
        var totalGtnQty = 0;
        var totalVariance = 0;
        reportData.forEach((row) => {
            totalVariance += row.variance ?? 0;
            row.inBound.forEach((inbound) => {
                totalWeightedQty += inbound.weightedQty;
                totalGrnAmount += inbound.weightedQty * inbound.grnPrice;
            });

            row.outBound.forEach((outbound) => {
                totalGtnQty += outbound.gtnQty ?? 0;
            });
        });

        setTotalValues({
            ...totalValues,
            totalgrnAmount: totalGrnAmount,
            totalweightedQty: totalWeightedQty,
            totalGtnQty: totalGtnQty,
            totalVariance: totalVariance
        })
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Quantity Variance FCC IQ Vs OQ Report">
                <Container>
                    <CommonPageHeader
                        path={"/FCCIQVsOQReport"}
                        btname="Add"
                        pageName="Quantity Variance FCC IQ Vs OQ Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center *"
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From Date *"
                                            value={date}
                                            onChange={(newValue) => {
                                                setDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('setDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.date && errors.date)}
                                                helperText={touched.date && errors.date}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('setToDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <div>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </div>
                            </Stack>
                            <br />
                            <>
                                {reportData.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#caedfb' }}>Order Details</TableCell>
                                                                    <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#fbe2d5' }}>Inbound Quantity</TableCell>
                                                                    <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#daf2d0' }}>Outbound Quantity</TableCell>
                                                                    <TableCell rowSpan={2} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e49edd' }}>Variance</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>FCC</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>SKU Code</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>SKU Description</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>Order Number</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f', whiteSpace: "nowrap" }}>Weighted Date</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>Weighted Qty</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>GRN Price</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>GRN Amount</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2', whiteSpace: "nowrap" }}>GTN Date</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>GTN Number</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2', whiteSpace: "nowrap" }}>Vehicle Number</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>GTN Quantity</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {stableSort(reportData, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const hasOutBound = row.outBound && row.outBound.length > 0;
                                                                        const variance = row.variance;

                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <TableRow>
                                                                                <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                                                                                        {row.factoryName}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                                                                                        {row.skuCode}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                                                                                        {row.skuDes}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                                                                                        {row.orderNo}
                                                                                    </TableCell>

                                                                                    {row.inBound.map((column, colIndex) => (
                                                                                        <React.Fragment key={`inbound-${colIndex}`}>
                                                                                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                                                                                                {moment(column.weightedDate).format("YYYY-MM-DD")}
                                                                                            </TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                                                                                {column.weightedQty == 0 || null ? "-" : parseFloat(column.weightedQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                                                                                {column.grnPrice == 0 || null ? "-" : parseFloat(column.grnPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                                                                                {column.grnAmount == 0 || null ? "-" : parseFloat(column.grnAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                        </React.Fragment>
                                                                                    ))}

                                                                                    {hasOutBound ? (
                                                                                        <>
                                                                                            <TableCell style={{ border: "1px solid black", whiteSpace: "nowrap" }}>{moment(row.outBound[0].gtnDate).format("YYYY-MM-DD")}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }}>{row.outBound[0].gtnNumber}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }}>{row.outBound[0].vehicleNumber}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} align="right">
                                                                                                {row.outBound[0].gtnQty == 0 || null ? "-" : parseFloat(row.outBound[0].gtnQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                                                                                {variance === 0 ? "-" : parseFloat(variance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                        </>
                                                                                    )
                                                                                        : (
                                                                                            <>
                                                                                                <TableCell colSpan={4} align="center" style={{ border: "1px solid black" }}>-</TableCell>
                                                                                                <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                                                                                    {variance === 0 ? "-" : parseFloat(variance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                            </>
                                                                                        )}
                                                                                </TableRow>

                                                                                {hasOutBound &&
                                                                                    row.outBound.slice(1).map((outBoundRow, outIndex) => (
                                                                                        <TableRow key={`outbound-${outIndex}`}>
                                                                                            <TableCell style={{ border: "1px solid black", whiteSpace: "nowrap" }}>{moment(outBoundRow.gtnDate).format("YYYY-MM-DD")}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }}>{outBoundRow.gtnNumber}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }}>{outBoundRow.vehicleNumber}</TableCell>
                                                                                            <TableCell style={{ border: "1px solid black" }} align="right">
                                                                                                {outBoundRow.gtnQty == 0 || null ? "-" : parseFloat(outBoundRow.gtnQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}

                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} colSpan={5}>Total</TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalweightedQty == 0 ? "-" : parseFloat(totalValues.totalweightedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell style={{ border: "1px solid black" }} align="right"></TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalweightedQty == 0 ? "-" : parseFloat(totalValues.totalgrnAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell style={{ border: "1px solid black" }} align="right" colSpan={3}></TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalGtnQty == 0 ? "-" : parseFloat(totalValues.totalGtnQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalVariance == 0 ? "-" : parseFloat(totalValues.totalVariance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={reportData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Quantity Variance FCC IQ Vs OQ Report" />}</>
                        </Form>
                    </FormikProvider>
                    {reportData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Quantity Variance FCC IQ Vs OQ Report" + new Date().toISOString().split('T')[0]}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    reportData={reportData}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}